import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload', 'upload', 'Добавить');
Labels.set('ui-upload', 'uploadFiles', 'Загрузить файлы');
Labels.set('ui-upload', 'clear', 'Убрать файл');
